export default function cleanStakeInput(stake) {
    return stake
        .replace(/[^0-9.]/g, '')
        .replace(/^\./, '0.')
}



// WEBPACK FOOTER //
// /src/js/common/utils/cleanStakeInput.js